import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import { SelectorViewModel } from "./SelectorViewModel";
import * as format from "../../common/FormatFunctions";
import * as Feedback from "../../common/Feedback/Feedback";

export class SBLSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: [],
      firstLoad: true,
      selectedAddressString: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      addressLine4: "",
      city: "",
      psotcode: ""
    };

    this.viewModel = new SelectorViewModel();
    this.logger = Log;
  }
  componentDidMount = () => {};

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setViewModel = () => {
    try {
      this.viewModel.updateState = this.updateState;
      this.viewModel.showError = this.showError;
      this.viewModel.showSuccess = this.showSuccess;
      this.viewModel.showEmpty = this.showEmpty;
    } catch (error) {}
  };

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };
  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };
  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  reset = list => {
    if (format.isNotNull(list)) {
      list.forEach(element => {
        this.updateState(element, null);
      });
    }
  };
  resetProps = list => {
    if (format.isNotNull(list)) {
      list.forEach(element => {
        this.props.updateState(element, null);
      });
    }
  };
  setPageData = async () => {
    if (this.props.type === "CLIENT") {
      if (this.props.businessId) {
        if (!this.state.siteOptions) {
          await this.viewModel.getSitesByClientId(this.props.businessId);
          if (this.state.firstLoad) {
            if (this.props.siteId) {
              this.getBuildingsFromSelectedSite(this.props.siteId);
            }
          }
        }
      }
    } else {
      if (!this.state.siteOptions) {
        await this.viewModel.getSites();
        if (this.state.firstLoad) {
          if (this.props.siteId) {
            this.getBuildingsFromSelectedSite(this.props.siteId);
          }
        }
      }
    }
  };

  getBuildingsFromSelectedSite = async id => {
    this.props.updateState("siteId", id);

    this.state.siteList.forEach(element => {
      if (element.id === id) {
        this.setState({
          addressLine1: element.addressLine1,
          addressLine2: element.addressLine2,
          city: element.town,
          postcode: element.postcode
        });
      }
    });
    await this.viewModel.getBuildings(id);
    if (this.state.firstLoad) {
      if (this.props.buildingId) {
        this.getLocationsFromSelectedBuilding(this.props.buildingId);
      }
    }
  };

  getLocationsFromSelectedBuilding = async id => {
    this.props.updateState("buildingId", id);
    this.state.buildingList.forEach(element => {
      if (element.id === id) {
        this.setState({ addressLine3: element.name });
      }
    });
    await this.viewModel.getLocations(id);
    if (this.state.firstLoad) {
      if (this.props.locationId) {
        this.finishAddressLoading(this.props.locationId);
      }
      this.setState({ firstLoad: false });
    }
  };

  finishAddressLoading = id => {
    if (format.isNotNull(id)) {
      this.props.updateState("locationId", id);
      console.log(this.state);
      var locationName = "";
      this.state.locationList.forEach(element => {
        if (element.id === id) {
          this.setState({ addressLine4: element.name });
          locationName = element.name;
        }
      });
    }
    var addressObject = {};
    addressObject.addressLine1 = this.state.addressLine1;
    addressObject.addressLine2 = this.state.addressLine2;
    addressObject.addressLine3 = this.state.addressLine3;
    addressObject.addressLine4 = locationName;
    addressObject.city = this.state.city;
    addressObject.postalZipCode = this.state.postcode;

    var addressString = format.readInAddressDetails(addressObject);
    if (this.props.showAddress === true) {
      this.setState({ selectedAddressString: addressString });
    }
  };

  render() {
    this.initialDataRender();

    return (
      <React.Fragment>
        {!format.isNotNull(this.state.selectedAddressString) && (
          <React.Fragment>
            <div className="ui-g-3">
              <label className="input-label">Site</label>
            </div>

            <div className="ui-g-9">
              <pr.Dropdown
                value={this.props.siteId || ""}
                options={this.state.siteOptions}
                onChange={e => {
                  this.resetProps(["buildingId", "locationId"]);
                  this.reset(["buildingOptions", "locationOptions"]);
                  this.getBuildingsFromSelectedSite(e.value);
                }}
                filter={true}
                filterBy="label"
                filterPlaceholder="Search"
                style={{ width: "100%" }}
                disabled={this.props.disabled}
                showClear={true}
              />
            </div>
          </React.Fragment>
        )}
        {format.isNotNull(this.props.siteId) &&
          !format.isNotNull(this.state.selectedAddressString) && (
            <React.Fragment>
              <div className="ui-g-3">
                <label className="input-label">Building</label>
              </div>

              <div className="ui-g-9">
                <pr.Dropdown
                  value={this.props.buildingId || ""}
                  options={this.state.buildingOptions}
                  onChange={e => {
                    this.resetProps(["locationId"]);
                    this.reset(["locationOptions"]);
                    this.getLocationsFromSelectedBuilding(e.value);
                  }}
                  filter={true}
                  filterBy="label"
                  filterPlaceholder="Search"
                  style={{ width: "100%" }}
                  disabled={this.props.disabled}
                  showClear={true}
                />
              </div>
            </React.Fragment>
          )}
        {format.isNotNull(this.props.buildingId) &&
          !format.isNotNull(this.state.selectedAddressString) && (
            <React.Fragment>
              <div className="ui-g-3">
                <label className="input-label">Location</label>
              </div>

              <div className="ui-g-9">
                <pr.Dropdown
                  value={this.props.locationId || ""}
                  options={this.state.locationOptions}
                  onChange={e => {
                    this.props.updateState("locationId", e.value);
                  }}
                  filter={true}
                  filterBy="label"
                  filterPlaceholder="Search"
                  style={{ width: "100%" }}
                  disabled={this.props.disabled}
                  showClear={true}
                />
              </div>
            </React.Fragment>
          )}
        {format.isNotNull(this.props.locationId) &&
          !format.isNotNull(this.state.selectedAddressString) &&
          this.props.showAddress === true && (
            <React.Fragment>
              <div className="ui-g-12">
                <pr.Button
                  label={"Save Address"}
                  icon="pi pi-save"
                  style={{
                    marginRight: ".25em",
                    float: "right",
                    background: this.props.buttonColour
                  }}
                  onClick={() => {
                    this.finishAddressLoading(this.props.locationId);
                  }}
                />
              </div>
            </React.Fragment>
          )}
        {format.isNotNull(this.state.selectedAddressString) && (
          <React.Fragment>
            <div className="ui-g-3">
              <label className="input-label">Address Selected</label>
            </div>

            <div className="ui-g-9">
              <textarea
                id={this.state.selectedAddressString + " Details"}
                disabled={true}
                rows={5}
                placeholder=""
                value={this.state.selectedAddressString}
                // onChange={e => {
                //   this.props.updateValue("clientDetails", e.target.value);
                // }}
                style={{ width: "100%", backgroundColor: "transparent" }}
              />
            </div>

            <div className="ui-g-12">
              <pr.Button
                label={"Edit Address"}
                icon="pi pi-pencil"
                style={{
                  marginRight: ".25em",
                  float: "right",
                  background: this.props.buttonColour
                }}
                onClick={() => {
                  this.setState({ selectedAddressString: null });
                }}
              />
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sites/SBLSelector.js